function replaceUrlParam(url, paramName, paramValue)
{
    if (paramValue == null) {
        paramValue = '';
    }
    var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');
    if (url.search(pattern)>=0) {
        return url.replace(pattern,'$1' + paramValue + '$2');
    }
    url = url.replace(/[?#]$/,'');
    return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
}

function updateHeroImage(id, newMobileSrc, newDesktopSrc) {
  const picture = document.querySelector(`picture[data-hero-id="${id}"]`);
  picture.querySelector('source[media="(max-width: 768px)"]').srcset = newMobileSrc;
  picture.querySelector('source[media="(min-width: 769px)"]').srcset = newDesktopSrc;
  picture.querySelector('img').src = newMobileSrc;
}



$(document).ready(function(){

  var bestSellingSwiper = new Swiper(".best-selling-swiper", {
    slidesPerView: 2,
    slidesPerGroup: 2,
    loopAddBlankSlides: false,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      enabled: false
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        loopAddBlankSlides: false,
        navigation: {
          enabled: true,
          nextEl: '.best-selling-swiper-button-next',
          prevEl: '.best-selling-swiper-button-prev',
        },
      },
    }
  })

  //Homepage Blog Section Swiper Slider
  let articleContainerSwiperInstance;

  function toggleArticleContainerSwiper() {
    const articleContainerSwiper = document.querySelector(".articles-container");
    if (!articleContainerSwiper) return;
    
    if (window.innerWidth < 769) {
      if (!articleContainerSwiperInstance) {
        articleContainerSwiperInstance = new Swiper(".articles-container", {
          slidesPerView: 1,
          spaceBetween: 25,
          centeredSlides: true,
          speed: 400,
        });
      }
    } else {
      if (articleContainerSwiperInstance) {
        articleContainerSwiperInstance.destroy(true, true);
        articleContainerSwiperInstance = null;
      }
    }
  }
  
  // Initial check
  toggleArticleContainerSwiper();
  // Re-check on window resize
  window.addEventListener("resize", toggleArticleContainerSwiper);

  //Parallax Image Swiper Slider
  let parallaxMobileSwiperInstance;
  
  function toggleParallaxMobileSwiper() {
    const parallaxMobileSwiper = document.querySelector(".parallax__mobile-slider");
    if (!parallaxMobileSwiper) return;

    if (window.innerWidth < 769) {
      if (!parallaxMobileSwiperInstance) {
        parallaxMobileSwiperInstance = new Swiper(".parallax__mobile-slider", {
          slidesPerView: 1,
          loop: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          }
        });
      }
    } else {
      if (parallaxMobileSwiperInstance) {
        parallaxMobileSwiperInstance.destroy(true, true);
        parallaxMobileSwiperInstance = null;
      }
    }
  }
  
  // Initial check
  toggleParallaxMobileSwiper();
  // Re-check on window resize
  window.addEventListener("resize", toggleParallaxMobileSwiper);


  /* Toggle Show More Button */
  $(".collapse-categories").on("click", function () {
    $hiddenBoxes = $('.category-carousel-item:nth-child(n+5)').slideToggle(500);
    $(this).toggleClass('clicked');
  });

  /* Tab Links */
  $('.tab-nav nav a ').each(function (index) {
    this.addEventListener('click', function (event) {
      event.preventDefault();
      toggle.call(this);
    });
  });

  var toggle = function () {
    if (!$(this).hasClass('active')) {
      var parent = $('.tab-content-wrap'),
        target = this.getAttribute('href').split('#').pop(),
        content = document.getElementById(target),
        toggles = document.querySelectorAll('.tab-content'),
        tabs = document.querySelectorAll('.tab-item');

      // Update visibility
      for (var i = 0, len = toggles.length; i < len; i++) {
        $(toggles[i]).removeClass('active').attr('aria-hidden', 'true');
        $(tabs[i]).removeClass('active');
        $(toggles[i]).find('.tab-animate').removeClass('in');
      }

      $(this).addClass('active');
      $(content).addClass('active').attr('aria-hidden', 'false');

      setTimeout(function () {
        $(content).find('.tab-animate').addClass('in');
      }, 100);
      
    }
  };

$("body").on('click', '.readers-powers button', function(){
	var vId = $(this).attr('variant-id');
  	var vStatus = $(this).attr('variant-status');
    var newPower = $(this).attr('variant-name').replace('+', '');
  	var atcForm = $(this).closest('.cc-collection-item').find('.shopify-product-form:first');
  	var container = $(this).parent();
  	var mainContainer = $(this).closest('.cc-collection-item');
    var urlSelector = $('.featured-container', mainContainer);
    var myHref = urlSelector.attr("href");
    var newHref = replaceUrlParam(myHref, 'power', newPower);
    urlSelector.attr("href", newHref);
  	$('.main-info h4 a', mainContainer).attr("href", newHref);
  	$('.review-wrap', mainContainer).attr("href", newHref);
  
  	$('button', container).removeClass('selected');
  	$(this).addClass('selected');
  	$('input[name=id]', atcForm).val(vId);
  	$('.BIS_trigger', atcForm).attr('data-variant-id',vId);
  	if(vStatus == "true"){
    	$('.BIS_trigger', atcForm).hide();
      	$('[data-atc]', atcForm).show();
    }
  	else{
    	$('.BIS_trigger', atcForm).show();
      	$('[data-atc]', atcForm).hide();
    }
});
$("body").on('click', ".snow-helmet-sizes button", function(){
	var vId = $(this).attr('variant-id');
  	var vStatus = $(this).attr('variant-status');
  	var atcForm = $(this).closest('.cc-collection-item').find('.shopify-product-form:first');
  	var container = $(this).parent();
  	$('button', container).removeClass('selected');
  	$(this).addClass('selected');
  	$('input[name=id]', atcForm).val(vId);
  	$('.BIS_trigger', atcForm).attr('data-variant-id',vId);
  	if(vStatus == "true"){
    	$('.BIS_trigger', atcForm).hide();
      	$('[data-atc]', atcForm).show();
    }
  	else{
    	$('.BIS_trigger', atcForm).show();
      	$('[data-atc]', atcForm).hide();
    }
});
$("body").on('click', ".rx-lens-colors .rx-swatch", function(){  
    var newImg = $(this).attr('rx-image');
    var newColor = $(this).attr('rx-color');
  	var container = $(this).closest('.cc-collection-item');
    var imgSelector = $('.featured-container img', container);
    var urlSelector = $('.featured-container', container);
    var myHref = urlSelector.attr("href");
    var newHref = replaceUrlParam(myHref, 'color', newColor);
  	$('.rx-lens-colors .rx-swatch', container).removeClass('selected');
  	$(this).addClass('selected');
    urlSelector.attr("href", newHref);
    imgSelector.attr("src", newImg);
    imgSelector.attr("data-hover-src", newImg);
  	$('.main-info h4 a', container).attr("href", newHref);
  	$('.review-wrap', container).attr("href", newHref);
    $('.shopify-product-form a', container).attr("href", newHref); 
 }); 

 function formatPrice(price, currency) {
   return new Intl.NumberFormat('en-US', {
     style: 'currency',
     currency: currency
   }).format(price);
 }

 var shopCurrency = Shopify.currency.active;

 function getLocalizedPrice(price, callback) {
    var convertedPrice = price;
    callback(convertedPrice);
 }

$('body').on('click','.sun-variants .sw-extra', function(){
	var newImg = $(this).attr('data-image');
  var newPrice = $(this).attr('data-price');
  var newHoverImg = $(this).attr('data-hover-image');
  var mainContainer = $(this).closest('.cc-collection-item');
  var imgSelector = $('.featured-container img', mainContainer);
  var priceSelector = $('.main-info .flow-price', mainContainer);
  var myHref = $(this).attr('data-href');
  var vId = $(this).attr('variant-id');
  var vJson = $(this).attr('data-product-json');
  var vStatus = $(this).attr('variant-status');
  var container = $(this).parent();
  var atcForm = $('.shopify-product-form', mainContainer);
  $('.sw-extra .bl-color-sun', container).removeClass('active');
  $('.bl-color-sun',this).addClass('active');
  imgSelector.attr("src", newHoverImg).attr('data-hover-src', newImg);
  $('.main-info h4 a', mainContainer).attr("href", myHref);
  $('.review-wrap', mainContainer).attr("href", myHref);
  $('.featured-container',mainContainer).attr("href", myHref);;
  $('input[name=id]', atcForm).val(vId);
  $('.BIS_trigger', atcForm).attr('data-variant-id',vId);
  $('.BIS_trigger', atcForm).attr('data-product-data',vJson);
  if(vStatus == "true"){
    $('.BIS_trigger', atcForm).hide();
      $('[data-atc]', atcForm).show();
  }
  else{
    $('.BIS_trigger', atcForm).show();
      $('[data-atc]', atcForm).hide();
  }
  // if (typeof Flow.getExperience === "function" && Flow.getExperience()) {
  //   priceSelector.attr("flow-variant", vId).attr('flow-default', newPrice);
  //   Flow.variants.localize(({ force: true }));
  // } else {
  //   priceSelector.attr("flow-variant", vId).attr('flow-default', newPrice).text(newPrice);
  // }

  getLocalizedPrice(newPrice, function(localizedPrice) {
    priceSelector
      .attr("globale-variant", vId)
      .attr("globale-default", newPrice)
      .text(formatPrice(localizedPrice, shopCurrency));
  });
});
$('.cc-collection-item [data-atc]').on('click', function(){
    var _learnq = _learnq || [];
    var klProductData = JSON.parse($(this).siblings('.BIS_trigger').attr('data-product-data'));
    var klCollections = $(this).attr('data-collections');
    var mainPrice = (klProductData.price / 100).toFixed(2).replace('.00', '');
	var comparePrice = "";
    if(klProductData.compare_at_price_max > 0 ){
    	comparePrice = (klProductData.compare_at_price_max / 100).toFixed(2).replace('.00', '');
    }
    var klDataObj = {
      Name: klProductData.title,
      ProductID: klProductData.id,
      Categories: klCollections,
      ImageURL: "https:" + klProductData.featured_image,
      URL: "https://blenderseyewear.com/products/" +  klProductData.handle,
      Brand: klProductData.vendor,
      Price: mainPrice,
      CompareAtPrice: comparePrice
    }
    _learnq.push(['track', 'Added to Cart', klDataObj]);
  });
});

